module.exports = __webpack_public_path__ + "media/images/brand/original/MARQUESBRANDINGCO LOGO VERTICAL-424125cce6f594c8d72439200559a717.png";